import { render } from "./index.vue?vue&type=template&id=2ac605ae&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Teams/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ac605ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ac605ae', __exports__)) {
    api.reload('2ac605ae', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2ac605ae&ts=true", () => {
    api.rerender('2ac605ae', render)
  })

}


export default __exports__